import Vue from 'vue'
import to from 'await-to-js'
import Axios from '@/config/axios'
import buildClient from '@/api/client'
import deleteSavedPaymentQuery from '@/api/delete-saved-payment'

const getRegisterGuestUrl = locale => {
  return `/${locale}/checkout/registration`
}

const getLoginUrl = locale => {
  return `/${locale}/login`
}

export default {
  namespaced: true,
  state: {
    currentUser: null,
  },

  mutations: {
    setState(state, payload) {
      state[payload[0]] = payload[1]
    },

    setUserData(state, userObject) {
      state.currentUser = { ...state.currentUser, ...userObject }
    },

    pushToAddresses(state, addressObject) {
      state.currentUser.addresses.push(addressObject)
    },

    deleteAddress(state, addressIndex) {
      state.currentUser.addresses.splice(addressIndex, 1)
    },

    setAddress(state, payload) {
      Vue.set(state.currentUser.addresses, payload[0], payload[1])
    },

    setAddressIsDefault(state, payload) {
      const address = state.currentUser.addresses[payload[0]]
      Vue.set(address, 'is_default', payload[1])
    },

    deleteSavedPayment(state, paymentReference) {
      buildClient()
        .query(deleteSavedPaymentQuery(paymentReference))
        .then(({ deleteSavedPayment: { success } }) => {
          if (success) {
            const newSavedPayments = state.currentUser.savedPayments.filter(
              payment => payment.reference !== paymentReference
            )
            state.currentUser = { ...state.currentUser, savedPayments: newSavedPayments }
          }
        })
        // Close opened confirmation modal
        .finally(() => $.featherlight.current().close())
    },
  },

  actions: {
    createAddress({ commit, dispatch }, addressObject) {
      dispatch('updateIfAddressExists', addressObject).then(addressExists => {
        if (!addressExists) {
          if (addressObject.is_default) {
            dispatch('resetDefaultAddressFlag')
          }
          commit('pushToAddresses', addressObject)
        }
      })
    },

    updateIfAddressExists({ dispatch, state }, addressObject) {
      return new Promise(resolve => {
        const addressExists = state.currentUser.addresses.some(
          address => address.id == addressObject.id
        )

        if (addressExists) {
          dispatch('updateAddress', addressObject)
        }
        resolve(addressExists)
      })
    },

    updateAddress({ commit, dispatch, state }, addressObject) {
      const addressIndex = state.currentUser.addresses.findIndex(
        address => address.id == addressObject.id
      )

      if (addressObject.is_default) {
        dispatch('resetDefaultAddressFlag', addressIndex)
      }
      commit('setAddress', [addressIndex, addressObject])
    },

    resetDefaultAddressFlag({ commit, state }, defaultAddressIndex) {
      state.currentUser.addresses.forEach((address, i) => {
        if (i != defaultAddressIndex) {
          commit('setAddressIsDefault', [i, false])
        }
      })
    },

    deleteSavedPayment({ commit }, paymentReference) {
      commit('deleteSavedPayment', paymentReference)
    },

    async isUserAccount({ dispatch }, email) {
      const [error] = await to(dispatch('getUserByEmail', email))
      return !error
    },

    getUserByEmail(context, email) {
      const query = `{ user(email: "${email}") { id } }`
      return buildClient()
        .query(query)
        .then(({ user }) =>
          user ? user : Promise.reject(new Error('No user available for given email'))
        )
    },

    loginGuest({ dispatch, rootGetters }, { email }) {
      // TODO: B2C-128 refactor into graphql call and update store
      const data = {
        order: {
          guest_checkout: true,
          email,
        },
      }
      return Axios.put(getRegisterGuestUrl(rootGetters['page/locale']), data)
        .then(data => dispatch('setRegistrationValid', data))
    },

    loginUser({ dispatch, rootGetters }, { email, password, rememberMe }) {
      // TODO: B2C-128 refactor into graphql call and update store
      const data = {
        spree_user: {
          email,
          password,
          remember_me: rememberMe,
        },
      }
      return Axios.post(getLoginUrl(rootGetters['page/locale']), data)
        .then(data => dispatch('setRegistrationValid', data))
    },

    setRegistrationValid({ commit }, data) {
      // TODO: B2C-128 replace with login data
      commit('checkout/setRegistrationValid', true, { root: true })
      return data
    },
  },

  getters: {
    currentUser: state => state.currentUser,
    orderedSavedPayments: state => {
      return state.currentUser
        ? state.currentUser.savedPayments.sort(payment => Date.parse(payment.createdAt))
        : []
    },
  },
}
